import { Component } from '@angular/core'

@Component({
    selector: '[ras-separator]',
    template: `<mat-divider></mat-divider>`,
    styles: [` mat-divider { margin: 25px 0; } `],
    standalone: false
})
export class SeparatorComponent {}
